import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Personeel } from '../dto/personeel';
import { CrudService, Filter } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class PersoneelService extends CrudService<Personeel> {

    constructor(injector: Injector) { super(Personeel, injector); }

    getProjectleiderFilter(): Filter<Personeel> {
        return new Filter<Personeel>(fb => [fb.equal("projectleider",true)]);
    }

    getActiefFilter(): Filter<Personeel> {
        return new Filter<Personeel>(fb => [fb.equal("actief",true)]);
    }
}
